import { jsxs as A, jsx as m } from "react/jsx-runtime";
import { FileSourceEnum as U } from "@systemeio/file-manager";
import { useEditor as z, EditorContent as q } from "./node_modules/@tiptap/react/dist/index.mjs";
import G from "./_virtual/index.mjs";
import { useState as W, useEffect as C } from "react";
import { twMerge as b } from "tailwind-merge";
import { CharacterCount as _ } from "./components/character-count.mjs";
import { baseExtensions as B } from "./constants/default-extensions.mjs";
import { EDITOR_PADDING as x } from "./constants/default-styles.mjs";
import { EditorExtensionEnum as J } from "./enums/editor-extensions-enum.mjs";
import { useImageDropAndUpload as K } from "./extensions/image-extension/use-image-drop-and-upload/index.mjs";
import { useInitContentWithLinkifiedText as Q } from "./extensions/link-extension/use-init-content-with-linkified-text.mjs";
import { Toolbar as V } from "./toolbar/index.mjs";
import { getExistingExtensions as X, getExtensions as Y } from "./utils/get-extensions.mjs";
import { useProcessContent as Z, preprocessPastedHtmlForEditor as $ } from "./utils/use-process-content.mjs";
import { convertStyleObjectToCss as O } from "./utils/style-helpers.mjs";
import { FontFamilyEnum as tt } from "./extensions/font-family-extension/utils.mjs";
const Ct = ({
  mode: r = "html",
  content: u,
  isPreFetching: c,
  isEditable: a = !0,
  extensions: l = B,
  className: y,
  toolbarStyles: T,
  characterCountHint: v,
  style: I,
  toolbarClassName: S,
  extensionOptions: o,
  showAllItems: w,
  skeletonClassName: P,
  defaultFont: D = tt.TimesNewRoman,
  onBlur: f,
  onChange: N
}) => {
  var E;
  const F = ((E = o == null ? void 0 : o[J.Image]) == null ? void 0 : E.fileSource) ?? U.TextEditor, { onDrop: L, onPaste: M } = K(F), [p, H] = W(!1), n = r === "html" ? "getHTML" : "getText", d = Array.from(new Set(l)), { hasImage: h, hasCharacterCount: R, hasSimpleLink: j } = X(d), { preprocessedContent: s, postprocessContent: g } = Z(u, r), k = (e) => $(e), t = z({
    content: s,
    immediatelyRender: !1,
    onCreate: () => H(!0),
    extensions: Y(d, o),
    onUpdate: ({ editor: e }) => {
      if (!p) return;
      const i = e.isEmpty ? "" : e[n]();
      N(g(i));
    },
    onBlur: ({ editor: e }) => {
      if (!p || !f) return;
      const i = e.isEmpty ? "" : e[n]();
      f(g(i));
    },
    editorProps: {
      handlePaste: h ? M : void 0,
      handleDrop: h ? L : void 0,
      transformPastedHTML: r === "html" ? k : void 0,
      attributes: {
        class: b(
          "border",
          "border-text-secondary/30",
          "main-transition-colors",
          "min-h-[500px]",
          "w-full",
          "focus:outline-hidden",
          "focus:border-brand-primary",
          "overflow-auto",
          "rounded-b-lg",
          !a && "pointer-events-none cursor-default",
          y
        ),
        style: O({
          paddingLeft: x,
          paddingRight: x,
          fontFamily: D,
          ...I
        })
      }
    }
  });
  return Q({
    editor: t,
    content: u,
    shouldInitialize: j && r === "text"
  }), C(() => {
    t && t.setOptions({ editable: a && !c });
  }, [a, c, t]), C(() => {
    if (!t) return;
    const e = G(() => {
      t[n]() !== s && t.commands.setContent(s, { emitUpdate: !1 });
    }, 300);
    return e(), () => {
      e.cancel();
    };
  }, [s, t, n]), t != null && t.isInitialized ? /* @__PURE__ */ A("div", { className: "relative", children: [
    l.length !== 0 && /* @__PURE__ */ m(
      V,
      {
        editor: t,
        extensions: d,
        toolbarStyles: T,
        toolbarClassName: S,
        showAllItems: w,
        extensionOptions: o
      }
    ),
    /* @__PURE__ */ m(q, { editor: t }),
    R && /* @__PURE__ */ m(
      _,
      {
        editor: t,
        hint: v,
        className: "ml-auto mt-2 mr-2 w-fit"
      }
    )
  ] }) : /* @__PURE__ */ m(
    "div",
    {
      className: b(
        "bg-background-tertiary h-[500px] w-full animate-pulse rounded-lg",
        P
      )
    }
  );
};
export {
  Ct as TipTapEditor
};
